module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/pelvis-c81925feba97a8374870945373c0cf96.png";